export const isZipCodeInputValid = (value: string): boolean => {
  if (!/^\d{0,5}$/.test(value)) {
    return false;
  }
  return true;
}
